

// Report Model
export class Report {
  constructor(data = {}) {
    this.id = data.id || null;
    this.userId = data.userId || '';
    this.reportType = data.reportType || '';
    this.transcription = data.transcription || '';
    this.annex = data.annex || undefined;
    this.content = data.content || '';
    this.correctedContent = data.correctedContent || undefined;
    this.isCorrected = data.isCorrected || false;
    this.isArchived = data.isArchived || false;
    this.isRead = data.isRead || false;
    this.structuredData = data.structuredData || {};
    this.status = data.status || 'pending';
    this.errorMessage = data.errorMessage || undefined;
    this.processingStartedAt = data.processingStartedAt ? new Date(data.processingStartedAt) : undefined;
    this.processingCompletedAt = data.processingCompletedAt ? new Date(data.processingCompletedAt) : undefined;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date();
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date();
    this.enterpriseId = data.enterpriseId || undefined;
    this.generatedBy = data.generatedBy || undefined;
    this.destinataire = data.destinataire || '';
  }
}
